import React from 'react'
import { config } from '../../config.js'
import { HEADERS } from '../api/api'

const API = config.apiUrl

const commonFetch = (props = {}) => {
    let { path, method, data = '' } = props

    let options = data
        ? Object.assign({}, optionsList[method], { body: data })
        : optionsList[method]

    return fetch(`${API}${path}`, options)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText)
            }
            return response
        })
        .then(response => response.json())
        .catch(err => {
            throw Error(err.message).stack
        })
}

const optionsList = {
    GET: {
        method: 'GET',
        headers: {},
        cache: 'no-store',
        credentials: 'include',
    },
    POST: {
        method: 'POST',
        headers: HEADERS,
        cache: 'no-store',
        credentials: 'include',
    },
}

export default commonFetch
